// Initialize the script
document.addEventListener("DOMContentLoaded", function () {
  handleProdSwiper();
  initAccordion();
  selectOnPriceChange();
  try {
    initModal();
  } catch (e) {
    console.error("Error initializing modal:", e);
  }
  initProdAccsAtcFeedback();

  const playButtons = document.querySelectorAll(".play-button");
  playButtons.forEach((button) => {
    button.addEventListener("click", function () {
      playVideo(this);
    });
  });
});

// Play YouTube video when the page loads
window.addEventListener("load", function () {
  playYoutubeVideo();
});

function handleProdSwiper() {
  console.log("Initializing product accessories swiper");

  // Check if the swiper elements exist before initializing Swiper
  const prodSwiperEl = document.querySelector(".prod-accs-swiper");
  const prodThumbSwiperEl = document.querySelector(".prod-accs-swiper-thumb");

  if (prodSwiperEl) {
    const swiperConfig = {
      spaceBetween: 5,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".prod-accs-swiper__button-next",
        prevEl: ".prod-accs-swiper__button-prev",
      },
      on: {
        slideChange: function () {
          resetVideos();
          resetYoutubeVideo(); // Reset YouTube videos when changing slides
        },
      },
    };

    if (prodThumbSwiperEl) {
      swiperConfig.thumbs = {
        swiper: new Swiper(prodThumbSwiperEl, {
          spaceBetween: 5,
          slidesPerView: 5,
          freeMode: true,
          watchSlidesProgress: true,
        }),
      };
    }

    // Initialize Swiper
    const prodSwiper = new Swiper(prodSwiperEl, swiperConfig);

    // Remove loading classes and hide skeleton after swiper initialization
    prodSwiperEl.classList.remove("prod-accs-swiper--loading");
    if (prodThumbSwiperEl) {
      prodThumbSwiperEl.classList.remove("prod-accs-swiper-thumb--loading");
      prodThumbSwiperEl
        .closest(".prod-accs__thumb-wrapper")
        .classList.remove("prod-accs__thumb-wrapper--loading");
    }
    const loadingSkeleton = document.querySelector(".prod-accs__loading");
    if (loadingSkeleton) {
      loadingSkeleton.style.display = "none";
    }
  }
}

/**
 * Plays the video in the slide and hides the play button.
 *
 * @param {HTMLElement} el - The play button element that triggered the video playback.
 */
function playVideo(el) {
  const videoElem = el
    .closest(".prod-accs-swiper__slide")
    .querySelector(".prod-accs__video");

  if (videoElem) {
    videoElem.setAttribute("controls", "controls");
    videoElem.play();
    el.parentElement.classList.add("hide-this");

    videoElem.addEventListener("ended", function () {
      resetSingleVideo(videoElem);
    });
  } else {
    console.error("Video element not found");
  }
}

/**
 * Resets all videos in the swiper to their initial state.
 * Pauses the videos, removes controls, and shows the play buttons.
 */
function resetVideos() {
  const videos = document.querySelectorAll(".prod-accs__video");
  videos.forEach((video) => {
    resetSingleVideo(video);
  });
}

/**
 * Resets a single video to its initial state.
 * Pauses the video, removes controls, and shows the play button.
 *
 * @param {HTMLVideoElement} video - The video element to reset.
 */
function resetSingleVideo(video) {
  video.pause();
  video.removeAttribute("controls");
  video.currentTime = 0;

  const playButtonWrapper = video
    .closest(".prod-accs-swiper__slide")
    .querySelector(".prod-accs__play-btn-wraper");
  if (playButtonWrapper) {
    playButtonWrapper.classList.remove("hide-this");
  }
}

/**
 * Initializes accordion functionality with exclusive opening behavior.
 */
function initAccordion() {
  const accordionItems = document.querySelectorAll(
    ".prod-accs__accordion-item"
  );
  let currentlyOpenItem = null;

  accordionItems.forEach((item) => {
    const summary = item.querySelector(".prod-accs__accordion-title");

    if (!summary) return;

    summary.addEventListener("click", function (event) {
      // Prevent the default toggle behavior
      event.preventDefault();

      if (currentlyOpenItem && currentlyOpenItem !== item) {
        // Close the previously open item
        currentlyOpenItem.open = false;
      }

      if (!item.open) {
        // Open this item
        item.open = true;
        currentlyOpenItem = item;
      } else {
        // If clicking on the open item, close it
        item.open = false;
        currentlyOpenItem = null;
      }
    });
  });
}

/**
 * Sets up price update functionality for product variants.
 *
 * This function initializes a price update mechanism for product variants.
 * It selects the price display element and the variant selection dropdown,
 * sets up an event listener to update the price when a new variant is selected,
 * and performs an initial price update.
 *
 * @function
 * @name selectOnPriceChange
 * @example
 * // Call the function when the DOM is fully loaded
 * document.addEventListener("DOMContentLoaded", selectOnPriceChange);
 */
function selectOnPriceChange() {
  const priceWrapper = document.querySelector(".prod-accs__price-value");
  const selectElem = document.querySelector(".prod-accs__g-card-select");

  // Guard clause - return early if elements don't exist
  if (!selectElem || !priceWrapper) {
    console.log("Price or select elements not found");
    return;
  }

  const renderPrice = ({ price, compare, hasCompare, previewActive }) => {
    priceWrapper.innerHTML = "";

    if (hasCompare && compare) {
      const compareEl = document.createElement("del");
      compareEl.className = "prod-accs__price-compare";
      compareEl.textContent = compare;
      priceWrapper.appendChild(compareEl);
    }

    const currentEl = document.createElement("span");
    currentEl.className = "prod-accs__price-current";
    currentEl.textContent = price;
    priceWrapper.appendChild(currentEl);

    priceWrapper.setAttribute("data-preview-active", previewActive);
  };

  // Function to update the price
  function updatePrice() {
    const selectedOption = selectElem.options[selectElem.selectedIndex];
    if (!selectedOption) return;

    const variantInput = document.getElementById("prod-accs-variant-id");
    if (variantInput) {
      variantInput.value = selectElem.value;
    }

    const nextPrice = selectedOption.getAttribute("data-price") || "";
    const nextCompare = selectedOption.getAttribute("data-compare-price") || "";
    const hasCompare =
      selectedOption.getAttribute("data-has-compare") === "true";
    const previewActive =
      selectedOption.getAttribute("data-preview-active") === "true";

    if (!nextPrice) {
      priceWrapper.textContent = selectedOption.textContent;
      priceWrapper.setAttribute("data-preview-active", previewActive);
      return;
    }

    renderPrice({
      price: nextPrice,
      compare: nextCompare,
      hasCompare,
      previewActive,
    });
  }

  // Add event listener to the select element
  selectElem.addEventListener("change", updatePrice);

  // Update the price when the page loads
  updatePrice();
}

/**
 * Initializes modal functionality for product accessories.
 */
function initModal() {
  const modalTriggers = document.querySelectorAll(
    ".prod-accs__modal-trigger-btn"
  );
  const customLiquid = document.querySelector(".prod-accs__custom-liquid");
  let previousActiveElement;

  // Move modal triggers on mobile
  function moveModalTriggers() {
    const isMobile = window.innerWidth <= 980;

    if (isMobile) {
      const style = {
        "margin-block-start": "1.3rem",
      };
      customLiquid.after(modalTriggers[0]);
      Object.assign(modalTriggers[0].style, style);
    } else {
      // Reset margin on desktop
      modalTriggers[0].style.marginBlockStart = "";
    }
  }

  // Initial move and listen for resize
  moveModalTriggers();
  window.addEventListener("resize", moveModalTriggers);

  // Modal functionality
  modalTriggers.forEach((trigger) => {
    const modal = document.getElementById(
      trigger.getAttribute("aria-controls")
    );
    const closeBtn = modal?.querySelector(".prod-accs__modal-close");

    if (!modal || !closeBtn) return;

    function openModal() {
      previousActiveElement = document.activeElement;
      modal.showModal();
      document.body.style.overflow = "hidden";
      closeBtn.focus();
    }

    function closeModal() {
      modal.close();
      document.body.style.overflow = "";
      previousActiveElement?.focus();
    }

    // Open modal
    trigger.addEventListener("click", openModal);

    // Close modal - multiple ways
    closeBtn.addEventListener("click", closeModal);
    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });
    modal.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeModal();
    });
  });
}

/**
 * Plays the YouTube video when the play button is clicked.
 * Hides the play button and shows the video wrapper.
 * Replaces the existing iframe with a new one that has autoplay enabled.
 */
function playYoutubeVideo() {
  const playButton = document.getElementById(
    "prod-accs-external-video-play-button"
  );
  const youtubeVideoWrapper = document.querySelector(
    ".prod-accs__external-video-wrapper-inner"
  );

  if (!playButton || !youtubeVideoWrapper) return;

  playButton.addEventListener("click", function (event) {
    event.preventDefault();

    youtubeVideoWrapper.classList.remove("hide-this");
    playButton
      .closest(".prod-accs__external-video-wrapper-preview-image-wrapper")
      .classList.add("hide-this");

    // Get existing iframe element
    const existingIframe = youtubeVideoWrapper.querySelector("iframe");
    if (!existingIframe) return;

    // Extract video ID from current iframe src
    const videoId = getYouTubeVideoId(existingIframe.src);
    if (!videoId) return;

    // Create a new iframe with autoplay enabled
    const newIframe = document.createElement("iframe");
    newIframe.setAttribute("frameborder", "0");
    newIframe.setAttribute("allowfullscreen", "allowfullscreen");
    newIframe.setAttribute(
      "allow",
      "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    );

    // Set the source URL with autoplay parameter
    newIframe.setAttribute(
      "src",
      `https://www.youtube.com/embed/${videoId}?controls=1&enablejsapi=1&modestbranding=1&playsinline=1&rel=0&autoplay=1`
    );

    // Copy other attributes from existing iframe
    if (existingIframe.hasAttribute("title")) {
      newIframe.setAttribute("title", existingIframe.getAttribute("title"));
    }
    if (existingIframe.hasAttribute("id")) {
      newIframe.setAttribute("id", existingIframe.getAttribute("id"));
    }

    // Replace the old iframe with the new one
    youtubeVideoWrapper.innerHTML = "";
    youtubeVideoWrapper.appendChild(newIframe);
  });
}

/**
 * Extracts the YouTube video ID from a URL
 *
 * @param {string} url - The YouTube iframe URL
 * @returns {string|null} - The video ID or null if not found
 */
function getYouTubeVideoId(url) {
  if (!url) return null;

  // Try to extract from various YouTube URL formats
  const regexps = [
    /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i,
    /(?:\/embed\/)([^"&?\/\s]{11})/i,
    /(?:[?&]v=)([^"&?\/\s]{11})/i,
  ];

  for (const regex of regexps) {
    const match = url.match(regex);
    if (match && match[1]) {
      return match[1];
    }
  }

  return null;
}

/**
 * Resets the YouTube video to its initial state.
 * Removes the iframe with the playing video and shows the play button.
 */
function resetYoutubeVideo() {
  const youtubeVideoWrapper = document.querySelector(
    ".prod-accs__external-video-wrapper-inner"
  );
  const playButtonWrapper = document.querySelector(
    ".prod-accs__external-video-wrapper-preview-image-wrapper"
  );

  if (!youtubeVideoWrapper || !playButtonWrapper) return;

  // Get the original iframe from data attribute or recreate it without autoplay
  const existingIframe = youtubeVideoWrapper.querySelector("iframe");
  if (existingIframe) {
    const videoId = getYouTubeVideoId(existingIframe.src);
    if (videoId) {
      // Create a new iframe without autoplay
      const newIframe = document.createElement("iframe");
      newIframe.setAttribute("frameborder", "0");
      newIframe.setAttribute("allowfullscreen", "allowfullscreen");
      newIframe.setAttribute(
        "allow",
        "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      );

      // Set the source URL without autoplay parameter
      newIframe.setAttribute(
        "src",
        `https://www.youtube.com/embed/${videoId}?controls=1&enablejsapi=1&modestbranding=1&playsinline=1&rel=0`
      );

      // Copy other attributes from existing iframe
      if (existingIframe.hasAttribute("title")) {
        newIframe.setAttribute("title", existingIframe.getAttribute("title"));
      }
      if (existingIframe.hasAttribute("id")) {
        newIframe.setAttribute("id", existingIframe.getAttribute("id"));
      }

      // Replace the playing iframe with the non-autoplay one
      youtubeVideoWrapper.innerHTML = "";
      youtubeVideoWrapper.appendChild(newIframe);
    }
  }

  // Hide video wrapper and show play button
  youtubeVideoWrapper.classList.add("hide-this");
  playButtonWrapper.classList.remove("hide-this");
}

function initProdAccsAtcFeedback() {
  const atcButton = document.getElementById("prod-accs-atc-button");

  if (!atcButton) {
    return;
  }

  const form = atcButton.closest("form");
  if (!form) {
    return;
  }

  const cartNotification = document.querySelector("cart-notification");
  const labelEl = atcButton.querySelector(".prod-accs__buy-btn-label");
  const resolveLabel = () => {
    const textSource = labelEl || atcButton;
    return textSource.textContent.trim();
  };

  const defaultLabel = atcButton.dataset.defaultLabel || resolveLabel();
  atcButton.dataset.defaultLabel = defaultLabel;

  let resetTimer = null;
  let isProcessing = false;

  const updateLabel = (text) => {
    if (!text) return;
    if (labelEl) {
      labelEl.textContent = text;
    } else {
      atcButton.textContent = text;
    }
  };

  const setLoadingState = (loading) => {
    isProcessing = loading;
    atcButton.disabled = loading;
    atcButton.dataset.loading = loading ? "true" : "false";
    atcButton.classList.toggle("loading", loading);
    atcButton.classList.toggle("is-loading", loading);
  };

  const setButtonState = (label, { loading } = {}) => {
    if (label) {
      updateLabel(label);
    }

    if (typeof loading === "boolean") {
      setLoadingState(loading);
    }
  };

  const scheduleReset = (delay = 1800) => {
    clearTimeout(resetTimer);
    resetTimer = window.setTimeout(() => {
      setButtonState(defaultLabel, { loading: false });
    }, delay);
  };

  const handleAddToCart = async (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (isProcessing) {
      return;
    }

    setButtonState("Adding item...", { loading: true });

    let payload = {};
    try {
      if (typeof serializeForm === "function") {
        payload = JSON.parse(serializeForm(form));
      } else {
        payload = Object.fromEntries(new FormData(form).entries());
      }
    } catch (error) {
      payload = Object.fromEntries(new FormData(form).entries());
    }

    if (
      cartNotification &&
      typeof cartNotification.getSectionsToRender === "function"
    ) {
      payload.sections = cartNotification
        .getSectionsToRender()
        .map((section) => section.id);
      payload.sections_url = window.location.pathname;
    }

    try {
      const requestConfig =
        typeof fetchConfig === "function"
          ? fetchConfig("javascript")
          : {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/javascript",
              },
            };

      const cartAddUrl =
        window.routes && window.routes.cart_add_url
          ? window.routes.cart_add_url
          : "/cart/add.js";

      console.log("DEBUG: Sending payload to /cart/add.js:", payload);
      const response = await fetch(cartAddUrl, {
        ...requestConfig,
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Add to cart failed with status ${response.status}`);
      }

      const parsedState = await response.json();

      if (
        cartNotification &&
        typeof cartNotification.renderContents === "function"
      ) {
        cartNotification.renderContents(parsedState);
      }

      // Manually trigger slide cart update
      if (typeof window.SLIDECART_UPDATED === "function") {
        SLIDECART_UPDATE();
        SLIDECART_OPEN();
      }

      setButtonState("Added item!", { loading: true });
      scheduleReset();
    } catch (error) {
      console.error("Accessory ATC error", error);
      setButtonState("Try again", { loading: false });
      scheduleReset(2000);
    }
  };

  console.log("DEBUG: Adding click listener to ATC button.");
  atcButton.addEventListener("click", handleAddToCart);
}
